import type { FunctionComponent } from 'react';
import { Navigate } from 'react-router';

export const RedirectToJobArchitectureV2: FunctionComponent = () => {
    return <Navigate to="/job-architecture-v2" />;
};
